import { render } from "./CollectionsPortfolio.vue?vue&type=template&id=0d480ae2"
import script from "./CollectionsPortfolio.vue?vue&type=script&lang=js"
export * from "./CollectionsPortfolio.vue?vue&type=script&lang=js"
script.render = render

export default script